var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.33 13.727l-3.572.789L23.222 35.7 14.26 51.66l2.443 13.78 15.813 8.641 11.764-.05 17.162.254 2.928-1.919.916-4.684-.916-1.937 4.38-.1 1.63-2.038 1.017-2.852-1.934-3.666 1.934-.816 2.343-3.258-1.12-3.361-3.056-1.427 1.426-2.648.204-4.175-3.158-1.834-16.092-.61-1.019-.816-1.044-.73H38.728l.078-2.121 4.786-11.714 2.037-5.602-.3-4.25z",
    fill: "#FFD6C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.066 72.845h-11c-10.17 0-17.11-8.165-17.11-18.333a23.976 23.976 0 016.11-15.89",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.32 38.623h-5.365l8.556-22c.99-2.547-3.41-4.645-6.111-1.222L21.066 38.623M45.77 42.9a4.627 4.627 0 004.889 4.279h15.889a4.316 4.316 0 100-8.556h-15.89A4.627 4.627 0 0045.77 42.9zM46.817 68.978a4.627 4.627 0 004.89 4.278h8.555a4.316 4.316 0 100-8.556h-8.556a4.627 4.627 0 00-4.889 4.278zM40.622 51.867a4.627 4.627 0 004.889 4.278h23.222a4.316 4.316 0 100-8.556H45.511a4.627 4.627 0 00-4.89 4.278z",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.066 60.422a4.627 4.627 0 004.89 4.278h18.332a4.316 4.316 0 100-8.555H47.956a4.627 4.627 0 00-4.889 4.277z",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.277 44.32a23.78 23.78 0 00-2.33 9.582c0 10.462 5.654 18.944 18.487 18.944",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

export default SvgThumbUp;